import { HttpContextToken } from '@angular/common/http';

/**
 * Quando true, o httpErrorInterceptor não redireciona para /access-denied em
 * erro 403 — usado por ações pontuais (não navegação de página) que precisam
 * exibir uma mensagem de permissão inline em vez de tirar o usuário da tela.
 */
export const BYPASS_403_REDIRECT = new HttpContextToken<boolean>(() => false);
